<div class="col-12 mb-2">
  <div *ngIf="inputConfig.control">
    <ng-container>
      <div class="col-12 mb-1">
        <ui-fh-label [labelConfig]="labelConfigs"></ui-fh-label>
      </div>
      <p-password
        autocomplete="{{ removeAutoComplete }}"
        [disabled]="inputConfig.disabled!"
        styleClass="w-100 p-input-icon-right"
        [inputStyleClass]="'w-100 inputs-style py-2 ' + inputConfig.class"
        [weakLabel]="'fields.password.meter.weak' | translate"
        [mediumLabel]="'fields.password.meter.medium' | translate"
        [strongLabel]="'fields.password.meter.strong' | translate"
        [promptLabel]="inputConfig.placeholder"
        [formControl]="inputConfig.control!"
        [(ngModel)]="password"
        [toggleMask]="inputConfig.toggleMaskPassword"
        [feedback]="inputConfig.passwordFeedback || showFeedback"
        [placeholder]="inputConfig.placeholder">
        <ng-template pTemplate="footer">
          <p-divider></p-divider>
          <p class="mt-2">{{ 'fields.password.rules.title' | translate }}</p>
          <ul class="pl-2 ml-0 mt-0" style="line-height: 1.5; list-style: none; padding-left: 0;">
            <li *ngIf="checkLower" [style.color]="password | fhPasswordValidation : 'lowercase'">
              <i [class]="'mx-2 '+ appConfig.icon + ((password | fhPasswordValidation : 'lowercase') == 'green' ? ' fa-circle-check' : ' fa-circle-xmark')"></i>
              <span>
                {{ 'fields.password.rules.lowercase' | translate }}
              </span>
            </li>
            <li *ngIf="checkUpper" [style.color]="password | fhPasswordValidation : 'uppercase'">
              <i [class]="'mx-2 '+ appConfig.icon + ((password | fhPasswordValidation : 'uppercase') == 'green' ? ' fa-circle-check' : ' fa-circle-xmark')"></i>
              <span>
                {{ 'fields.password.rules.uppercase' | translate }}
              </span>
            </li>
            <li *ngIf="checkNumeric" [style.color]="password | fhPasswordValidation : 'numeric'">
              <i [class]="'mx-2 '+ appConfig.icon + ((password | fhPasswordValidation : 'numeric') == 'green' ? ' fa-circle-check' : ' fa-circle-xmark')"></i>
              <span>
                {{ 'fields.password.rules.numeric' | translate }}
              </span>
            </li>
            <li *ngIf="checkSymbol" [style.color]="password | fhPasswordValidation : 'symbol'">
              <i [class]="'mx-2 '+ appConfig.icon + ((password | fhPasswordValidation : 'symbol') == 'green' ? ' fa-circle-check' : ' fa-circle-xmark')"></i>
              <span>
                {{ 'fields.password.rules.symbol' | translate }}
              </span>
            </li>
            <li *ngIf="checkSpace" [style.color]="password | fhPasswordValidation : 'space'">
              <i [class]="'mx-2 '+ appConfig.icon + ((password | fhPasswordValidation : 'space') == 'green' ? ' fa-circle-check' : ' fa-circle-xmark')"></i>
              <span>
                {{ 'fields.password.rules.space' | translate }}
              </span>
            </li>
            <li *ngIf="checkQuantity" [style.color]="password | fhPasswordValidation : 'quantity'">
              <i [class]="'mx-2 '+ appConfig.icon + ((password | fhPasswordValidation : 'quantity') == 'green' ? ' fa-circle-check' : ' fa-circle-xmark')"></i>
              <span>
                {{ 'fields.password.rules.quantity' | translate }}
              </span>
            </li>
          </ul>
        </ng-template>
      </p-password>
    </ng-container>
    <div *ngIf="inputConfig.control" class="error-message">
      <small class="p-error block ps-3" *ngIf="inputConfig.control?.touched && inputConfig.control?.errors">{{
        inputConfig.control.errors!['error'] | translate
      }}</small>
    </div>
  </div>
</div>
